var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Fily;
(function (Fily) {
    var Review;
    (function (Review) {
        var FlushMessage = (function (_super) {
            __extends(FlushMessage, _super);
            function FlushMessage() {
                var _this = _super.call(this, { delegate: false }) || this;
                _this.showReviewPostSuccessMessage();
                return _this;
            }
            FlushMessage.prototype.showReviewPostSuccessMessage = function () {
                var flashMessage = sessionStorage.getItem('reviewFlushMessage');
                if (flashMessage) {
                    $('.js-review-flush-message').css('display', 'flex');
                    $('.js-review-flush-message-text').text(flashMessage);
                    setTimeout(function () {
                        $('.js-review-flush-message').fadeOut('slow');
                    }, 5000);
                    sessionStorage.removeItem('reviewFlushMessage');
                }
            };
            return FlushMessage;
        }(Fily.BaseView));
        Review.FlushMessage = FlushMessage;
    })(Review = Fily.Review || (Fily.Review = {}));
})(Fily || (Fily = {}));
